import MusicalQuote from './MusicalQuote.vue'

export default MusicalQuote
